<template>
  <div v-if="visible" class="teacher-class-switcher">
    <UiSelect
      :label="label"
      :options="classOptions"
      :model-value="currentClassId"
      @update:modelValue="handleChange"
    />
  </div>
</template>

<script>
import UiSelect from '@/components/ui/UiSelect.vue'

export default {
  name: 'TeacherClassSwitcher',
  components: { UiSelect },
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    teacherClasses() {
      return this.$store.state.teacherClasses || []
    },
    currentClassId() {
      const cls = this.$store.state.teacherClass
      return cls?.id ?? cls?.class_id ?? ''
    },
    visible() {
      return this.$store.state.role === 'teacher' && this.teacherClasses.length > 1
    },
    classOptions() {
      return this.teacherClasses.map(item => ({
        value: item.id ?? item.class_id,
        label: `${item.name}${item.isHeadTeacher ? '（班主任）' : '（任课教师）'}`
      }))
    }
  },
  methods: {
    async handleChange(classId) {
      if (!classId || String(classId) === String(this.currentClassId)) return
      await this.$store.dispatch('selectTeacherClass', classId)
      if (this.$route.path.startsWith('/teacher/home-school') && this.$store.state.teacherIsHeadTeacher === false) {
        this.$router.replace('/')
      }
    }
  }
}
</script>

<style scoped>
.teacher-class-switcher {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
}

.teacher-class-switcher :deep(.ui-field) {
  display: inline-flex;
  margin: 0;
  width: auto;
}

.teacher-class-switcher :deep(.ui-select) {
  width: auto;
  min-width: 0;
  height: 42px;
  min-height: 42px;
  padding-top: 0;
  padding-bottom: 0;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .teacher-class-switcher,
  .teacher-class-switcher :deep(.ui-select) {
    min-width: 100%;
    width: 100%;
  }

  .teacher-class-switcher :deep(.ui-select) {
    height: 38px;
    min-height: 38px;
  }
}

@media (max-width: 480px) {
  .teacher-class-switcher :deep(.ui-select) {
    height: 36px;
    min-height: 36px;
  }
}
</style>
